import { Divider } from '@dixa/lib-shared-habla';
import { Fragment, useMemo } from 'react';

import { DEFAULT_PINNED_STATE } from 'components/editorCopilotDropdown';
import { useServerStorage } from 'utils/useServerStorage';

import { Undo } from './components/undo';
import {
  type ConditionArgs,
  type PinnedActionProps,
} from './copilotPinnedActions.types';

export const CopilotPinnedActions = (
  props: PinnedActionProps,
): JSX.Element | null => {
  const storage = useServerStorage('user');

  const conditionArgs: ConditionArgs = {
    pinState: {
      // Default values
      ...DEFAULT_PINNED_STATE,
      // User storage values override defaults
      ...storage.data.agent_copilot?.pinned,
    },
  };

  const hasPinnedItem = useMemo(() => {
    return Object.values(storage.data?.agent_copilot?.pinned || {}).some(
      (copilotActionEnabled) => copilotActionEnabled,
    );
  }, [storage.data?.agent_copilot?.pinned]);
  return (
    <>
      {hasPinnedItem && <Divider orientation="vertical" />}
      {props.pinnableActions.map((pinnable) => {
        const Component = pinnable.component;
        const shouldRender = pinnable.condition(conditionArgs);

        if (!shouldRender) {
          return null;
        }

        return (
          <Fragment key={pinnable.id}>
            <Component
              {...{
                ...props,
                ...(pinnable.label && { label: pinnable.label }),
                ...(pinnable.disabledImprovements && {
                  disabledImprovements: pinnable.disabledImprovements,
                }),
              }}
            />
          </Fragment>
        );
      })}
      <Undo />
    </>
  );
};
